module.exports = __webpack_public_path__ + "static/Aneta_Koubkova_TogetherAgain-1a24ed8fc6b0f596481e5cb3961c8061.mp3";